import { render } from "./image-left-two-offers.vue?vue&type=template&id=36d3e2a9"
import script from "./image-left-two-offers.vue?vue&type=script&lang=js"
export * from "./image-left-two-offers.vue?vue&type=script&lang=js"
script.render = render

export default script